export enum SubmissionModuleState {
  None = 'none', // 'none' is a placeholder for 'null' or 'undefined
  Compilation = 'compilation',
  Sign = 'sign',
  Completed = 'completed',
}
